import React, { useState } from "react";
import { Container, Row, Col } from "reactstrap";
import profile from "../profile";
import moment from "moment";
import { Media } from "reactstrap";
import {Collapse, Button} from "react-bootstrap";
import ufs from '../images/ufs.png';
import nwu from '../images/nwu.png';
import saao from '../images/saao.png';

let imagelogo ={
    ufs, nwu, saao
};




function getDuration(duration) {
  const years = parseInt(duration / 12);
  const months = (duration > 12)? duration % 12 : duration
  return (years > 0? years + " year" + (years > 1? "s": "") + " and " : "") + (months > 0? months + " month" + (months > 1? "s": "") : "");
};

class Experience extends React.Component {

  render() {
    return <Container>
      <Row>
        <Col>
          {profile.experiences.map(function (experience, i) {
            moment.locale('en');

            const totalDuration = experience.roles.reduce(function (cnt, role) {
              const startDate = moment(role.startDate);
              const timeEnd = moment(role.currentJob ? new Date() : new Date(role.endDate));
              const duration = moment.duration(timeEnd.diff(startDate));
              return Number(cnt) + Number(duration.asMonths().toPrecision(1));
            }, 0);

            return (
              <div key={i}>
                <Media>
                  <Media left top href={experience.url}>
                    <Media object src={imagelogo[experience.logo]} alt={experience.companyName}/>
                  </Media>
                  <Media body>
                    <Media heading>
                      <a href={experience.url}>{experience.companyName}</a>
                      <span className="jobTotalDuration">{getDuration(totalDuration)}</span>
                    </Media>

                    {experience.roles.map(function (role, i) {
                      const startDate = moment(role.startDate);
                      const timeEnd = moment(role.currentJob ? new Date() : new Date(role.endDate));
                      const duration = Number(moment.duration(timeEnd.diff(startDate)).asMonths().toPrecision(1));
                      const index = experience.id;
                      return <div key={index}>
                        <h5>{role.title}</h5>
                        <span
                          className="jobDuration">{startDate.format('MMM YYYY')} - {role.currentJob ? 'Present' : timeEnd.format('MMM YYYY')} ({getDuration(duration)})</span>
                        <span className="jobLocation">{role.location}</span>
                        <p className="jobDescription">{role.description}</p>
                        <div key={index} className="listJobrole" >
                          <ShowCollapse role={role}/>
                        </div>
                      </div>
                    })}
                  </Media>
                </Media>
              </div>
            );
          })}
        </Col>
      </Row>
    </Container>
  }
}


function ShowCollapse(props) {
  const role = props.role;
  const [open, setOpen] = useState(false);

  return (
    <>
      <Collapse in={open} style={{display:"block !important", height:"96px !important", overflow:"hidden"}}>
        <div id="example-collapse-text" height="120px"> 
          <ul>
            {role.list_description.map(function (role_list, ii){
              return(
                  <li key={ii} style={{margin:"0px", fontSize:"16px"}}><i>{role_list}</i></li> 
              );
            })}
          </ul>
        </div>
      </Collapse>
      <Button id="collapsed" style={{margin:"0px 30px", backgroundColor: "transparent", color: "blue", border: 'none'}}
        onClick={() => setOpen(!open)}
        aria-controls="example-collapse-text"
        aria-expanded={open}
      >
      [{open ? 'Show less':'Show more'}]
      </Button>
    </>
  );
}

export default Experience;